import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  FlexContainer,
  SecondaryButton,
  ScrollableContainer,
  AnimatedList,
} from "../../components/styled";
import DeckCard from "../../components/shared/deckCard";
import NoveIcon from "../../assets/images/logo/tokens/nova.png";
import { useSlot } from "../../context/SlotContext";
import { useCryptidSelectModal } from "../../hooks/useCryptidSelectModal";
import { useDeck } from "../../context/DeckContext";
import { useBottomSheet } from "../../context/BottomSheetContext";
import BuySlotModalContent from "../../components/buySlotModalContent";
import { useNavigate } from "react-router-dom";
// import {useWalletContext} from "../../context/WalletContext";

const Collection = (props) => {
  const { cards, deck, sort } = props;
  const { clearSlots } = useDeck();
  const [sortType, setSortType] = useState("desc");
  const { setOpen, setCard, setInSlot } = useSlot();
  const [displayCards, setDisplayCards] = useState(cards);

  const { openCryptidSelectModal, closeCryptidSelectModal } =
    useCryptidSelectModal();

  const onSelectCard = (card) => {
    closeCryptidSelectModal();
    setCard(card);
    setOpen(true);
  };
  const handleSlotClick = (index) => {
    if (deck?.slots[index] === undefined) {
      const filteredCards = cards.filter(
        (card) => !deck?.slots.find((s) => s._id === card._id),
      );
      if (filteredCards.length === 0) {
        alert("All cards in your deck");
        return;
      }
      openCryptidSelectModal(filteredCards, onSelectCard);
      return;
    }
    addSlot(deck?.slots[index], true);
  };
  const handleUserCardClick = (index) => {
    const card = cards[index];
    console.log(card);

    if (!card) return;
    const { slots } = deck;
    console.log(slots);
    if (slots.find((s) => s._id === card._id)) {
      addSlot(card, true);
      return;
    }
    addSlot(card, false);
  };

  const addSlot = (card, inSlot) => {
    if (!card) return;
    setCard(card);
    setInSlot(inSlot);
    setOpen(true);
  };
  useEffect(() => {
    if (displayCards.length !== cards.length) {
      setDisplayCards(cards);
    }
  }, [cards]);
  const handleSort = () => {
    sort(sortType === "asc" ? "desc" : "asc");
    setSortType(sortType === "asc" ? "desc" : "asc");
  };

  return (
    <ScrollableContainer style={{ position: "relative" }}>
      <FlexContainer
        flexdirection="column"
        gap="0px"
        style={{ overflow: "hidden", transition: "height .3s linear" }}
      >
        <CollectionTop {...deck} />
        <GridTop
          title="My Deck"
          buttons={{
            first: {
              text: "Auto Build",
              action: () => alert("Auto Build"),
            },
            second: {
              text: "Clear All",
              action: () => clearSlots(),
            },
          }}
        />
        <GridContainer>
          {Array(24)
            .fill(0)
            .map((_, i) => (
              <AnimatedList key={i} style={{ animationDelay: `${i * 0.03}s` }}>
                <DeckCard
                  clickAction={() => handleSlotClick(i)}
                  card={deck?.slots[i]}
                  containerStyle={containerStyle}
                  isLocked={i >= deck?.slotCount}
                />
              </AnimatedList>
            ))}
        </GridContainer>
      </FlexContainer>
      <FlexContainer
        flexdirection="column"
        gap="0px"
        style={{
          height: "100%",
          transition: "all .3s ease-in-out",
          position: "absolute",
        }}
      >
        <GridTop
          title="My Collection"
          buttons={{
            first: {
              text: "Sort By Rarity",
              action: handleSort,
            },
            second: {
              text: "Type",
              action: () => alert("type Filter"),
            },
          }}
        />
        <GridContainer2>
          {Array(displayCards.length < 12 ? 12 : displayCards.length)
            .fill(0)
            .map((_, i) => (
              <AnimatedList key={i} style={{ animationDelay: `${i * 0.03}s` }}>
                {" "}
                <DeckCard
                  clickAction={() => handleUserCardClick(i)}
                  containerStyle={
                    i <= displayCards.length - 1 ? FilledStyle : null
                  }
                  card={displayCards[i]}
                />
              </AnimatedList>
            ))}
        </GridContainer2>
      </FlexContainer>
    </ScrollableContainer>
  );
};

export default Collection;

const CollectionTop = (props) => {
  const { openSheet, closeSheet } = useBottomSheet();
  const navigate = useNavigate();
  const openBuySlotModal = () => {
    openSheet({
      content: <BuySlotModalContent navigate={navigate} onClose={closeSheet} />,
      title: "Buy Slot",
    });
  };
  return (
    <DeckDetails>
      <FlexContainer
        flexdirection="column"
        gap="8px"
        style={{ alignItems: "flex-start" }}
      >
        <span>
          {props?.slots.length || 0}/{props?.slotCount || 24} ⚔️{" "}
          <strong style={{ margin: "0 8px" }}>ATK:</strong>
          {(props?.totalMiningPower * 2).toFixed(2) || 0}
        </span>
        <span>
          <strong>Total:</strong>
          <img
            src={NoveIcon}
            alt="Nove Icon"
            style={{
              width: "16px",
              height: "16px",
              marginLeft: "8px",
              marginRight: "8px",
            }}
          />
          {props?.totalMiningPower.toFixed(2) || 0.0}/d
        </span>
      </FlexContainer>
      <SecondaryButton
        onClick={openBuySlotModal}
        bordered
        style={{ height: "32px", width: "88px" }}
      >
        {"Buy Slot"}
      </SecondaryButton>
    </DeckDetails>
  );
};
const GridTop = (props) => {
  const { title, buttons } = props;
  return (
    <GridContainerTop>
      <span>{title}</span>
      <ButtonsContainer>
        {buttons.first.text !== "Auto Build" && (
          <SecondaryButton
            bordered
            onClick={buttons.first.action}
            style={{ height: "100%" }}
          >
            {buttons.first.text}
          </SecondaryButton>
        )}

        <SecondaryButton
          onClick={buttons.second.action}
          style={{ height: "100%" }}
        >
          {buttons.second.text}
        </SecondaryButton>
      </ButtonsContainer>
    </GridContainerTop>
  );
};

const containerStyle = {
  boxShadow: "0px 2px 0px 0px #6747AC",
  borderWidth: "0.59px",
};
const FilledStyle = {
  border: "none",
  boxShadow: "none",
};
const DeckDetails = styled(FlexContainer)`
  height: 70px;
  background: #d9d9d914;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 8px;
  margin-top: 4px;
  justify-content: space-between;
  padding: 0 16px;
  span {
    font-size: 0.8em;
    display: flex;
    align-items: center;
  }
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 100%;
`;
const GridContainer2 = styled(GridContainer)`
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  overflow-y: auto;
  padding-bottom: 34px;
`;
const GridContainerTop = styled(FlexContainer)`
  height: 32px;
  justify-content: space-around;
  margin: 16px 0;
  span {
    font-size: 1em;
    white-space: nowrap;
  }
`;
const ButtonsContainer = styled(FlexContainer)`
  height: 100%;
  gap: 8px;
  justify-content: flex-end;
`;
